import { jsx as _jsx } from "react/jsx-runtime";
import { Alert } from "@mui/material";
import { clientConfigFn } from "clientConfig";
const FutureDatedWarningText = ({ date }) => {
    if (date > new Date() &&
        clientConfigFn().futureDatedTransferWarning.trim() !== "") {
        return (_jsx(Alert, { severity: "warning", children: clientConfigFn().futureDatedTransferWarning }));
    }
    else {
        return null;
    }
};
export default FutureDatedWarningText;
